import { useState } from "react";
import Button from "../common/Button";
import BaseModal from "../modals/BaseModal";
import { APPOINTMENT_SERVICE_OPTIONS } from "../../utils/constants";

const EMPTY_FORM = {
  contact_name: "",
  phone_number: "",
  requested_date: "",
  requested_time: "",
  service_type: "consultation",
  summary: "",
};

export default function NewAppointmentModal({ open, busy, onClose, onSubmit }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errorText, setErrorText] = useState("");

  const update = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleClose = () => {
    if (busy) {
      return;
    }
    setErrorText("");
    onClose();
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (busy) {
      return;
    }

    const payload = {
      contact_name: form.contact_name.trim(),
      phone_number: form.phone_number.trim(),
      requested_date: form.requested_date.trim(),
      requested_time: form.requested_time.trim(),
      service_type: form.service_type,
      summary: form.summary.trim(),
    };

    if (
      !payload.contact_name ||
      !payload.phone_number ||
      !payload.requested_date ||
      !payload.requested_time
    ) {
      setErrorText("Contact name, phone, date, and time are required.");
      return;
    }

    setErrorText("");
    onSubmit(payload, () => setForm(EMPTY_FORM));
  };

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      title="New Appointment"
      meta="Manually add an appointment to the calendar."
      modalId="newAppointmentModal"
    >
      <form className="outbound-form" onSubmit={handleSubmit}>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptName">
            Contact Name
          </label>
          <input
            className="outbound-input"
            id="apptName"
            type="text"
            placeholder="Contact name"
            value={form.contact_name}
            onChange={(event) => update("contact_name", event.target.value)}
            required
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptPhone">
            Phone Number
          </label>
          <input
            className="outbound-input"
            id="apptPhone"
            type="tel"
            placeholder="+971501234567"
            value={form.phone_number}
            onChange={(event) => update("phone_number", event.target.value)}
            required
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptDate">
            Date
          </label>
          <input
            className="outbound-input"
            id="apptDate"
            type="date"
            value={form.requested_date}
            onChange={(event) => update("requested_date", event.target.value)}
            required
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptTime">
            Time
          </label>
          <input
            className="outbound-input"
            id="apptTime"
            type="time"
            value={form.requested_time}
            onChange={(event) => update("requested_time", event.target.value)}
            required
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptService">
            Category
          </label>
          <select
            className="outbound-input"
            id="apptService"
            value={form.service_type}
            onChange={(event) => update("service_type", event.target.value)}
            disabled={busy}
          >
            {APPOINTMENT_SERVICE_OPTIONS.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="apptSummary">
            Summary (optional)
          </label>
          <textarea
            className="outbound-input"
            id="apptSummary"
            rows={3}
            placeholder="Notes or reason for the appointment"
            value={form.summary}
            onChange={(event) => update("summary", event.target.value)}
            disabled={busy}
          />
        </div>
        {errorText ? (
          <div className="outbound-help outbound-help-error">{errorText}</div>
        ) : null}
        <div className="outbound-actions">
          <Button type="button" onClick={handleClose} disabled={busy}>
            Cancel
          </Button>
          <Button type="submit" variant="green" disabled={busy}>
            {busy ? "Saving..." : "Create Appointment"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
